import Icon from '../components/Icon.vue'

Icon.register({
  'pen-alt': {
    width: 512,
    height: 512,
    paths: [
      {
        d: 'M497.9 74.2c18.8 18.8 18.8 49.2 0 67.9l-56.6 56.5-128-128 56.5-56.6c18.8-18.8 49.2-18.8 67.9 0zM251.1 53.6l84.9 84.9 82.8 82.8-196.8 196.8c-44.8 44.8-132.3 86.8-195.3 93.8-15.3 1.7-28.2-11.2-26.5-26.5l0-0.2c7-62.9 49-150.3 93.8-195.1l151.6-151.6-22.6-22.6-101.8 101.8c-6.3 6.3-16.4 6.3-22.6 0l-22.6-22.6c-6.3-6.2-6.3-16.4 0-22.6l118.8-118.8c15.6-15.6 40.9-15.6 56.6 0z'
      }
    ]
  }
})



//////////////////
// WEBPACK FOOTER
// ./~/vue-awesome/icons/pen-alt.js
// module id = 1620
// module chunks = 0